import * as toastr from 'toastr';


export class AlertConfig {
  type!: 'success' | 'error' | 'info' | 'warning';
  title!: string;
  body!: string;
}
const open = (alert: AlertConfig) => {
  toastr.options.closeButton = true;
  toastr.options.progressBar = false;
  toastr.options.timeOut = 5000;
  toastr.options.positionClass = "toast-top-right";
  toastr.options.debug = true;
  let customClass = '';
  if (alert.type === 'success') {
    customClass = 'toast-success custom-icon';
  } else if (alert.type === 'error') {
    customClass = 'toast-error custom-icon';
  } else if (alert.type === 'warning') {
    customClass = 'toast-warning custom-icon';
  } else {
    customClass = 'toast-info custom-icon';
  }
  return toastr[alert.type](alert.body, alert.title, { iconClass: customClass });
}

const alertErrorF = (alert: AlertConfig) => {
  toastr.options.closeButton = true;
  toastr.options.progressBar = false;
  toastr.options.timeOut = 0;
  toastr.options.extendedTimeOut = 0;
  toastr.options.positionClass = "toast-top-right";
  toastr.options.debug = true;
  let customClass = '';
  if (alert.type === 'error') {
    customClass = 'toast-error custom-icon';
  }
  return toastr[alert.type](alert.body, alert.title, { iconClass: customClass });
}

export const alertService = {
  /**
   *
   * @param type success||error||info||warning
   * @param title title - any string
   * @param body body - any string
   *
   */
  serviceErrorMessage: (message: string, messageTitle?: string) => {
    const alertConf: AlertConfig = { type: 'error', title: messageTitle || 'Failed : ', body: message || '' };
    // alertErrorF(alertConf);
    open(alertConf)
  },
  serviceSuccessMessage: (message: string) => {
    const alertConf: AlertConfig = { type: 'success', title: 'Success : ', body: message || '' };
    open(alertConf);
  },
  serviceWarningMessage: (message: string) => {
    const alertConf: AlertConfig = { type: 'warning', title: 'Warning : ', body: message || '' };
    open(alertConf);
  }
}
